import { useMutation, useQueryClient } from '@tanstack/react-query'

import { putRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
export const useMutateReferralShareStatus = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: { id: number; status: string }) =>
      putRequest(`/referral-shares/status?id=${params.id}&status=${params.status}`),
    onSuccess: (_, params) => {
      queryClient.invalidateQueries({ queryKey: queries.referralShares.list._def })
      queryClient.invalidateQueries({ queryKey: queries.referralShares.detail(params.id).queryKey })
      queryClient.invalidateQueries({ queryKey: queries.referrals._def })
    },
  })
}
